import React, { Component } from 'react';
class Spinner extends Component {
   constructor(props, context) {
      super(props, context);
      
      this.align = this.props.align ? this.props.align : 'right';
  }

  render() {
    return (
      <div className="spinnerHolder" style={{float : this.align}}>
        <i className="fa fa-spinner fa-spin" style={{fontSize : "24px", color : "black"}}></i>
      </div>
    )
  }
}
  
export default Spinner


// WEBPACK FOOTER //
// ./src/components/FormComponents/Spinner.js